import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import WITBulkEdit = require("WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls.BulkEdit");
import Dialogs = require("VSS/Controls/Dialogs");
import VSS = require("VSS/VSS");
import TCMTelemetry_LAZY_LOAD = require("TestManagement/Scripts/TFS.TestManagement.Telemetry")

export class BulkEditTestCases {
    public _bulkEditTestCases(testCaseIds: number[], projectTypeMapping: IDictionaryStringTo<string[]>) {
        let options = {
            workItemIds: testCaseIds,
            width: 600,
            minWidth: 450,
            height: 450,
            minHeight: 300,
            attachResize: true,
            tfsContext: TFS_Host_TfsContext.TfsContext.getDefault(),
            okCallback: function (dialogResult) {
                let bulkOptions = {
                    container: this._element
                };

                WITBulkEdit.bulkUpdateWorkItems(TFS_Host_TfsContext.TfsContext.getDefault(),
                    dialogResult.workItemIds,
                    dialogResult.changes,
                    bulkOptions);
                VSS.using(["TestManagement/Scripts/TFS.TestManagement.Telemetry"],
                    (TCMTelemetry: typeof TCMTelemetry_LAZY_LOAD) => {
                        TCMTelemetry.TelemetryService.publishEvents(TCMTelemetry.TelemetryService.featureEditTestCaseDialog_SaveTestCases, {
                            "TestCaseCount": testCaseIds.length
                        });
                    });
            },
            projectTypeMapping: projectTypeMapping
        };

        Dialogs.show(WITBulkEdit.BulkEditWorkItemDialog, options);
    }
}